import { notificationsApi as notificationsApiUrl } from '../../utils/urls';
import { rootApi } from '../../services/rootApi';


export const notificationsApiSlice = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query({
      query: ({ types, reversed, pageLength }) => {
        const data = {
          reversed,
          includeRead: true
        };

        if (types && ['3', '6', '10'].includes(types)) {
          data.types = [types];
        }

        return {
          url: notificationsApiUrl(),
          method: 'POST',
          body: {
            data: data,
            method: 'read',
            pageLength: pageLength,
            pageStart: 0
          }
        };
      },
      transformResponse: (response) => response.data,
      providesTags: ['Notifications']
    }),

    markNotification: builder.mutation({
      query: ({ ids, method, markAll }) => ({
        url: notificationsApiUrl(),
        method: 'POST',
        body: {
          data: {
            ids,
            all: markAll
          },
          method: method
        }
      }),
      transformResponse: (response) => response.data,
      invalidatesTags: ['Notifications', 'UnreadCount'],
    }),
    getUnreadCount: builder.query({
      query: () => ({
        url: notificationsApiUrl(),
        method: 'POST',
        body: {
          data: {},
          method: 'count'
        }
      }),
      transformResponse: (response) => response.data,
      providesTags: ['UnreadCount']
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetNotificationsQuery,
  useMarkNotificationMutation,
  useGetUnreadCountQuery,
} = notificationsApiSlice;
